
import DocaInputField from '../DocaInputField';

export function DocumentInputField({
    value,
	loading,
	Submit,
	isPassport,
	onChangePassCode
}) {
    return (
        <>
			<div className="doca-flex doca-justify-center doca-items-center doca-mb-5">
				<div className="doca-w-full doca-px-4" style={{ maxWidth: "288px"}}>
					<div>
						<DocaInputField
							disabled={loading}
							value={value}
							placeholder={'9999999999'}
							docaMaxWidth={72}
							docaHeight={12}
							docaTextSize="large"
							onChange={onChangePassCode}
						/>
					</div>

					<span className="doca-text--gray doca-text--normal doca-text--extra-small">Sem caracteres adicionais. Ex: {isPassport ? 'AA999999' : 'A9999999'}</span>
				</div>
			</div>

			<div>
				<button className="doca-button doca-button--primary doca-w-full doca-justify-center" onClick={Submit} disabled={loading}>
					<i className="doca-icon doca-icon__pen-line doca-icon--regular" />
					Acessar documento
				</button>
			</div>
        </>
    );
};


